import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { JobService } from "../../Network/services/JobService";
import ShareJob from "../ShareJob";
import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Files from "react-files";
import { LoadingOverlay, Loader } from "react-overlay-loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "react-modal";
import FilePreview from "../FilePreview";

const mapStateToProps = (state) => ({
  ...state.articleList,
});

const mapDispatchToProps = (dispatch) => ({
  onTabClick: (tab, pager, payload) =>
    dispatch({ type: CHANGE_TAB, tab, pager, payload }),
});

const MyQuoteDetailView = (props) => {
  let location = useLocation();
  let history = useHistory();

  const normalizePaymentTerms = (paymentTerms) => {
    if (!paymentTerms) return "By Terms"; 
    const normalized = paymentTerms.toLowerCase().trim();
    if (normalized.includes("milestone")) return "By Milestone";
    if (normalized.includes("completion")) return "By Completion";
    if (normalized.includes("terms") || normalized.includes("fws")) return "By Terms";
    if (paymentTerms === "By Terms" || paymentTerms === "By Milestone" || paymentTerms === "By Completion") {
      return paymentTerms;
    }
    return "By Terms"; 
  };

  const [selected, setSelected] = useState(normalizePaymentTerms(location.state.item.payment_terms));
  const [description, setDescrption] = useState("");
  const [amount, setAmount] = useState("");
  const [scopefile, setScopefile] = useState({  });
  const [scopeValidation, setScopeValidation] = useState("");
  const [BidAmount, setBidAmount] = useState(location.state.item.bid_amount);
  const [scope, setScope] = useState("");
  const [loading, setLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(true);
  const [isCancelModelopen, setIsCancelModelopen] = useState(false);
  const [comment, setComment] = useState("");
  const [openShareJob, setOpenSharejob] = useState(false);

  const [milestoneView, setMilestoneView] = useState([]);
  const [milestoneDes, setMilestoneDes] = useState([]);
  const [milestoneAmount, setMilestoneAmount] = useState([]);
  const [addedscope, setAddedscope] = useState("");
  const [attachement, setAttachement] = useState({});
  const [additionalCondition, setAdditionalCondition] = useState("");
  const [filesLoading, setFilesLoading] = useState(false);

  useEffect(() => {
    const normalizedTerm = normalizePaymentTerms(location.state.item.payment_terms);
    setSelected(normalizedTerm);
    
    setMilestoneView([]);
    setMilestoneDes([]);
    setMilestoneAmount([]);
    
    if (location.state.item.payment_milestone != null) {
      if (location.state.item.payment_milestone.length > 0) {
        setDescrption(
          location.state.item.payment_milestone[0].milestone_descriction
        );
        setMilestoneView(location.state.item.payment_milestone.slice(1));
        setAmount(location.state.item.payment_milestone[0].milestone_amount);

        location.state.item.payment_milestone.slice(1).forEach((item, i) => {

          setMilestoneDes((milestone) => [
            ...milestone,
            item.milestone_descriction,
          ]);
          setMilestoneAmount((milestoneAmount) => [
            ...milestoneAmount,
            item.milestone_amount,
          ]);
        });
      }
    }
    if (location.state.item.work_scope != null) {
      setScope(location.state.item.work_scope);
    }
    if (location.state.item.attach_portfolio != null) {
      setAddedscope(location.state.item.attach_portfolio);
    }
    if (location.state.item.additional_comment != null) {
      setAdditionalCondition(location.state.item.additional_comment);
    }
    if (location.state.item?.job_files_attachment && location.state.item.job_files_attachment.length > 0) {
      setFilesLoading(true);
      setTimeout(() => {
        setFilesLoading(false);
      }, 500);
    }
  }, []);
  let back = (e) => {
    e.preventDefault();
    history.goBack();
  };

  let cancelModelClose = () => {
    setIsCancelModelopen(false);
  };

  const toggleModel = () => {
    setOpenSharejob(!openShareJob);
  };


  function onFilesChange(event) {
    let file = event.target.files[0];


    if (file.size > 10e6) {
      toast.success("File size must be less than 2MB", {
              position: "top-right",
              type: "error",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
            });
      return;
    }
    setScopefile(event.target.files[0]);
  }

 
  const onFilesError = (error, file) => {


    setScopeValidation(error.message);
  };
  function humanFileSize(size) {
    var i = Math.floor(Math.log(size) / Math.log(1024));
    return (
      (size / Math.pow(1024, i)).toFixed(2) * 1 +
      " " +
      ["B", "kB", "MB", "GB", "TB"][i]
    );
  }
  const onCompletion = (e) => {
    e.preventDefault();
    setSelected("By Completion");
    setMilestoneView([]);
    setMilestoneDes([]);
    setMilestoneAmount([]);
  };
  const onbyTerms = (e) => {
    e.preventDefault();
    setSelected("By Terms");
    setMilestoneView([]);
    setMilestoneDes([]);
    setMilestoneAmount([]);
  };
  const onMilestone = (e) => {
    e.preventDefault();
    setSelected("By Milestone");
    setMilestoneView([]);
    setMilestoneDes([]);
    setMilestoneAmount([]);
  };
  const cancelClick = (e) => {
    e.preventDefault();
    setIsCancelModelopen(true);
  };


  const cancelQuote = () => {
  
    setLoading(true);
    const form = new FormData();
    form.append("quote_id", location.state.item.quote_id);
    form.append("cancel_comment", comment);
    

    JobService.cancelQuote(form, true)
      .then(async (res) => {
        if (res.status == 200) {
          history.goBack();
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        } else {
          history.goBack();

          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };



  const submitquote = () => {

    setLoading(true);
    
    if (selected === "By Milestone") {
      const staticAmount = parseFloat(amount) || 0;
      const dynamicAmount = milestoneAmount.reduce((sum, amt) => {
        return sum + (parseFloat(amt) || 0);
      }, 0);
      const totalMilestoneAmount = Math.round(staticAmount + dynamicAmount);
      const bidAmountParsed = Math.round(parseFloat(BidAmount) || 0);
      
      if (totalMilestoneAmount !== bidAmountParsed) {
        toast.error(`Total milestone amount (${totalMilestoneAmount}) must equal bid amount (${bidAmountParsed})`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setLoading(false);
        return;
      }
      
      const staticDescriptionEmpty = !description.trim();
      const dynamicDescriptionsEmpty = milestoneDes.filter(desc => !desc.trim());
      
      if (staticDescriptionEmpty || dynamicDescriptionsEmpty.length > 0) {
        toast.error("Please provide descriptions for all milestones", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setLoading(false);
        return;
      }
    }
    
    setLoading(true);
    const form = new FormData();
    form.append("quote_id", location.state.item.quote_id);
    form.append("job_bid_type", selected);
    form.append("bid_payment_terms", "");
    form.append(
      "milestone_descriction[]",
      selected == "By Milestone"
        ? description == ""
          ? milestoneDes.join(",")
          : description + "," + milestoneDes.join(",")
        : ""
    );
    form.append("work_scope", scope);
    form.append("amount", BidAmount);
    form.append(
      "milestone_amount[]",
      selected == "By Milestone"
        ? amount == ""
          ? milestoneAmount.join(",")
          : amount + "," + milestoneAmount.join(",")
        : ""
    );
    form.append("additional_comment", additionalCondition);

    if (scopefile.name != null) {
      form.append("attach_portfolio", scopefile);
    }

    JobService.submitquote(form, true)
      .then(async (res) => {
        if (res.status == 200) {
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
           setTimeout(() => {window.location.href = '/myjobs'},1000)
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <section className="explore explore1">
      <div className="container">
        <div className="banner">
          <div className="row">
            <div className="col-md-6">
              <div className="breadcrumps">
                <ul>
                  <li>
                    <div onClick={back}>
                      <a href="#">
                        <i className="bx bx-chevron-left" /> Back to My Jobs
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-6 quote-detail-text-align-right">
              <a href="#!" className="btn" onClick={toggleModel}>
                 Share this Job
              </a>
            </div>
          </div>
        </div>
        <div className="explore-details">
          <div className="row">
            <div className="col-md-7">
              <p className="jobid">
                Job#{" "}
                <span>
                  {" "}
                  {location.state.item.job_unique_id.substr(
                    location.state.item.job_unique_id.indexOf(" ") + 1
                  )}
                </span>
              </p>
              <ul className="list-one">
              
              </ul>
              <h1 className="title">{location.state.item.job_title}</h1>
              <ul className="list-two">
                <li>
                  <a href="#!">
                    {location.state.item.job_location} <span>|</span>
                  </a>
                </li>
               
                <li>
                  <a href="#!">
                    {location.state.item.payment_terms} <span>|</span>
                  </a>
                </li>
                <li>
                  <a href="#!" />
                  {location.state.item.timestamp} <span>|</span>
                </li>
                <li>
                  <a href="#!">
                  Targeted close Date {location.state.item.target_closed_date}{" "}
                    <span>|</span>
                  </a>
                </li>
                <li>
                  <a href="#!">
                    {location.state.item.total_quotes_received} Quotes Received
                  </a>
                </li>
                
              </ul>
              
              <p className="job-details-label quote-detail-job-label-no-margin">Project Budget </p>
              <div className="payment-amount">
                ₹{location.state.item.bid_amount}
              </div>
              <p className="job-details-label">Category</p>
              <div className="job-category">
                {location.state.item?.parent_category_name && location.state.item?.category_full_name
                  ? `${location.state.item.parent_category_name} > ${location.state.item.category_full_name}`
                  : location.state.item?.category_full_name || location.state.item?.category || 'General'}
              </div>
              {location.state.item?.skills && (
                <>
                  <p className="job-details-label">Required Skills</p>
                  <ul className="category-list">
                    {location.state.item.skills.split(',').map((skill, index) => (
                      <li key={index} className="skill-tag">
                        {skill.trim()}
                      </li>
                    ))}
                  </ul>
                </>
              )}
              <p className="job-details-label quote-detail-job-label-no-margin">About Job</p>
              <p>{location.state.item.job_description}</p>
              
              {location.state.item?.job_files_attachment && location.state.item.job_files_attachment.length > 0 && (
                <>
                  <p className="job-details-label">Attachments</p>
                  <LoadingOverlay>
                    <div className="form-group myresume-file-preview-container">
                      {location.state.item.job_files_attachment.map((file, index) => (
                        <FilePreview 
                          key={index}
                          fileUrl={file}
                        />
                      ))}
                    </div>
                    <Loader loading={filesLoading} />
                  </LoadingOverlay>
                </>
              )}

              
            </div>
            {isEdit ? (
              <div className="col-md-5">
                <div className="sidebar">
                  <LoadingOverlay>
                    <h1 className="title">Edit Quote</h1>
                    <div className="quote-detail-plan-info-box">
                      <h6 className={location.state.item?.job_plan?.is_premium === "0" ? "quote-detail-plan-title-lite" : "quote-detail-plan-title"}>
                        {location.state.item?.job_plan?.subscription_name} Plan
                      </h6>
                      <p className={`quote-detail-plan-description ${location.state.item?.job_plan?.is_premium === "0" ? "quote-detail-plan-description-lite" : ""}`}>
                        {location.state.item?.job_plan?.is_premium === "0" 
                          ? "Escrow fund not available for fund protection and Payment terms must be directly discussed and agreed"
                          : "Get Escrow protection, priority support, and extra benefits for a secure, hassle-free experience."
                        }
                      </p>
                    </div>
                    <h6>Amount you would like to quote for this job?</h6>
                    <div className="col-md-12 quote-detail-no-padding-right">
                      <input
                        type="text"
                        name
                        value={BidAmount}
                        className="quote-detail-bid-input"
                        onChange={(e) => {
                          const value = e.target.value;
                          
                          const numericRegex = /^[0-9]*\.?[0-9]*$/;
                          
                          if (value === '' || numericRegex.test(value)) {
                            const numericValue = parseFloat(value);
                            
                            
  
                            if (value !== '' && (numericValue < 1 || numericValue >= 1000000)) {
                              toast.error("Bid amount should be between 1 and 9,99,999 INR", {
                                toastId: "bid-amount-exceed-limit",
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                              });
                              return; 
                            }
                            
                            setBidAmount(value);
                          } else {
                            toast.error("Please enter only numeric values", {
                              toastId: "numeric-validation-error",
                              position: "top-right",
                              autoClose: 3000,
                              hideProgressBar: false,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                              progress: undefined,
                            });
                          }
                        }}
                        placeholder="Biding Amount"
                      />
                    </div>

                    <h6>
                      Choose a Payment term{" "}
                      <img src="/assets/images/exclamation.png" />
                    </h6>
                    <ul className="payment">
                      <li>
                        <Link
                          to="#"
                          className={selected === "By Terms" ? "quote-detail-payment-border-selected" : "quote-detail-payment-border-default"}
                          onClick={onbyTerms}
                        >
                          <img src="/assets/images/terms.png" />
                          <span>By GigFWS Term</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className={selected === "By Milestone" ? "quote-detail-payment-border-selected" : "quote-detail-payment-border-default"}
                          onClick={onMilestone}
                        >
                          <img src="/assets/images/milestone.png" />
                          <span>By Milestone</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className={selected === "By Completion" ? "quote-detail-payment-border-selected" : "quote-detail-payment-border-default"}
                          onClick={onCompletion}
                        >
                          <img src="/assets/images/completion.png" />
                          <span>By Completion</span>
                        </Link>
                      </li>
                    </ul>
                    {selected === "By Milestone" ? (
                      <div>
                        <p>
                          You can divide the project into different small
                          milestones and paid up after completing each one of
                          them.
                        </p>
                        <div className="milestones">
                          <form>
                            <div className="row">
                              <div
                                className="col-md-6 quote-detail-no-padding-right"
                              >
                                <input
                                  type="text"
                                  name
                                  value={description}
                                  className="quote-detail-milestone-input-bg"
                                  onChange={(e) => {
                                    const value = e.target.value.replace(/,/g, '');
                                    setDescrption(value);
                                  }}
                                  placeholder="Details about Milestone"
                                />
                              </div>
                              <div
                                className="col-md-2 quote-detail-no-padding-right"
                              >
                                <input
                                  type="text"
                                  name
                                  value={amount}
                                  className="quote-detail-milestone-input-bg"
                                  onChange={(text) => {
                                    const value = text.target.value;
                                    const numericRegex = /^[0-9]*\.?[0-9]*$/;

                                    if (value === '' || numericRegex.test(value)) {
                                      const numericValue = parseFloat(value);

                                      if (value !== '' && (numericValue >= 1000000 || numericValue < 1)) {
                                        toast.error("Milestone amount should be between 1 and 9,99,999 INR", {
                                          toastId: "milestone-amount-exceed-limit",
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                      });
                                      return; 
                                    }

                                      setAmount(value);
                                    } else {
                                      toast.error("Please enter only numeric values", {
                                        toastId: "milestone-numeric-validation-error",
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                      });
                                    }
                                  }}
                                  placeholder="Amount"
                                />
                              </div>
                              <div
                                className="col-md-4 quote-detail-no-padding-right"
                              >
                                <button
                                  className="btn send quote-detail-milestone-button"
                                  disabled={(amount ? 1 : 0) + milestoneAmount.length >= 20}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    
                                    const totalMilestones = (amount ? 1 : 0) + milestoneAmount.length;
                                    
                                    if (totalMilestones >= 20) {
                                      toast.error("Maximum 20 milestones allowed", {
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                      });
                                      return;
                                    }
                                    
                                    if (!BidAmount || !/^\d+$/.test(BidAmount)) {
                                      toast.error("Please enter a valid bid amount first", {
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                      });
                                      return;
                                    }
                                    
                                    const staticAmount = parseFloat(amount) || 0;
                                    const dynamicAmount = milestoneAmount.reduce((sum, amt) => {
                                      return sum + (parseFloat(amt) || 0);
                                    }, 0);
                                    const totalMilestoneAmount = staticAmount + dynamicAmount;
                                    
                                    const remainingAmount = parseFloat(BidAmount) - totalMilestoneAmount;
                                    
                                    if (remainingAmount <= 0) {
                                      toast.error("Total milestone amount already equals or exceeds bid amount", {
                                        position: "top-right",
                                        autoClose: 3000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                      });
                                      return;
                                    }
                                    
                                    setMilestoneView([...milestoneView, milestoneView.length]);
                                    setMilestoneAmount([...milestoneAmount, remainingAmount.toString()]);
                                    setMilestoneDes([...milestoneDes, ""]);
                                  }}
                                >
                                  Add Milestone
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                        {milestoneView.map((value, index) => (
                          <div className="milestones">
                            <form>
                              <div className="row">
                                <div
                                  className="col-md-6 quote-detail-no-padding-right"
                                >
                                  <input
                                    type="text"
                                    name
                                    value={
                                      milestoneDes.length > index
                                        ? milestoneDes[index]
                                        : ""
                                    }
                                    className="quote-detail-milestone-input-bg"
                                    onChange={(text) => {
                                      const value = text.target.value.replace(/,/g, '');
                                      setMilestoneDes([
                                        ...milestoneDes.slice(0, index),
                                        value,
                                        ...milestoneDes.slice(index + 1),
                                      ]);
                                    }}
                                    placeholder="Details about Milestone"
                                  />
                                </div>
                                <div
                                  className="col-md-2 quote-detail-no-padding-right"
                                >
                                  <input
                                    type="text"
                                    name
                                    value={
                                      milestoneAmount.length > index
                                        ? milestoneAmount[index]
                                        : ""
                                    }
                                     className="quote-detail-milestone-input-bg"
                                    onChange={(text) => {
                                      const value = text.target.value;
                                      const numericRegex = /^[0-9]*\.?[0-9]*$/;
                                      
                                      if (value === '' || numericRegex.test(value)) {
                                        const numericValue = parseFloat(value);
                                        
                                        if (value !== '' && (numericValue >= 1000000 || numericValue < 1)) {
                                        toast.error("Milestone amount should be between 1 and 9,99,999 INR", {
                                          toastId: "milestone-amount-exceed-limit",
                                          position: "top-right",
                                          autoClose: 3000,
                                          hideProgressBar: false,
                                          closeOnClick: true,
                                          pauseOnHover: true,
                                          draggable: true,
                                          progress: undefined,
                                        });
                                        return; 
                                      }

                                        if (value !== '' && BidAmount) {
                                          const currentMilestoneAmounts = [...milestoneAmount];
                                          currentMilestoneAmounts[index] = value;
                                          const totalMilestoneAmount = currentMilestoneAmounts.reduce((sum, amt) => {
                                            return sum + (parseFloat(amt) || 0);
                                          }, 0);
                                          
                                          if (totalMilestoneAmount > parseFloat(BidAmount)) {
                                            toast.error(`Total milestone amount (${totalMilestoneAmount}) cannot exceed bid amount (${BidAmount})`, {
                                              toastId: "milestone-total-exceed-bid",
                                              position: "top-right",
                                              autoClose: 3000,
                                              hideProgressBar: false,
                                              closeOnClick: true,
                                              pauseOnHover: true,
                                              draggable: true,
                                              progress: undefined,
                                            });
                                            return; 
                                          }
                                        }
                                        
                                      setMilestoneAmount([
                                        ...milestoneAmount.slice(0, index),
                                          value,
                                        ...milestoneAmount.slice(index + 1),
                                      ]);
                                      } else {
                                        toast.error("Please enter only numeric values", {
                                          toastId: "milestone-numeric-validation-error",
                                          position: "top-right",
                                          autoClose: 3000,
                                          hideProgressBar: false,
                                          closeOnClick: true,
                                          pauseOnHover: true,
                                          draggable: true,
                                          progress: undefined,
                                        });
                                      }
                                    }}
                                    placeholder="Amount in Rupees"
                                  />
                                </div>
                                <div
                                  className="col-md-4 quote-detail-no-padding-right"
                                >
                                  <button
                                    className="btn send quote-detail-milestone-remove-button"
                                    onClick={(e) => {
                                      e.preventDefault();




                                      setMilestoneView(
                                        milestoneView.filter(
                                          (item, indexid) => indexid !== index
                                        )
                                      );
                                      setMilestoneDes(
                                        milestoneDes.filter(
                                          (item, indexid) => indexid !== index
                                        )
                                      );
                                      setMilestoneAmount(
                                        milestoneAmount.filter(
                                          (item, indexid) => indexid !== index
                                        )
                                      );
                                    }}
                                  >
                                    Remove Milestone
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        ))}
                      </div>
                    ) : selected === "By Terms" ? (
                      <ul className="payment-list">
                        <li>20 % Payment @ Intial</li>
                        <li>60 % Payment @ After Service Done</li>
                        <li>
                          20 % Payment @ After Reviewing the entire service
                        </li>
                      </ul>
                    ) : null}
                    <form>
                      <label>Scope of Work</label>
                      <textarea
                        type="text"
                        name
                        value={scope}
                        onChange={(e) => {

                          setScope(e.target.value);
                        }}
                        placeholder="You can ask Additional Enquiries here"
                        defaultValue={""}
                      />
                      <p>
                        Material costs, transportation and all other additional
                        resource costs may/ may not be added. Please ask any
                        questions upfront and get it clarified. You can mention
                        any of your queries in the above box.
                      </p>
                     
                      <div className="files">
                        <p className="file">
                          <label htmlFor="file">
                            <input
                              className="FileUpload1"
                              id="FileInput"
                              name="booking_attachment"
                              type="file"
                              onChange={onFilesChange}
                              onError={onFilesError}
                              accept="image/*,.pdf"
                              accepts={["image/png", "image/jpg",".pdf"]}
                              maxFileSize={1800000}
                              minFileSize={0}
                              clickable
                            />
                            <img src="/assets/images/attachments.png" />
                            {scopefile.name==null?"Attach your Proposal and Portfolio":scopefile.name}
                          </label>
                        </p>
                        {location.state.item.attach_portfolio && (
                          <div className="existing-attachment">
                            <p className="attachment-label">Current Attachment:</p>
                            <FilePreview fileUrl={location.state.item.attach_portfolio} />
                          </div>
                        )}
                        <label className="error">{scopeValidation}</label>
                      </div>
                    </form>
                    <form>
                      <label>Additional Condition</label>
                      <textarea
                        type="text"
                        name
                        value={additionalCondition}
                        onChange={(e) => {
                          setAdditionalCondition(e.target.value);
                        }}
                        style={{marginBottom: '20px'}}
                        placeholder="Add any additional conditions or requirements here"
                        defaultValue={""}
                      />
                    </form>
                    {location.state.item.is_awarded === null ? <div className="row">
                      <div className="col-md-6 text-center">
                        <button className="btn cancel" onClick={cancelClick} >Withdraw Quote</button>
                      </div>
                      <div className="col-md-6 text-center">
                        <button className="btn send" onClick={submitquote}>
                          Update Quote
                        </button>
                      </div>
                    </div> : <p style={{textAlign: 'center'}}>Job is awarded to someone</p>}
                    <Loader loading={loading} />
                  </LoadingOverlay>
                </div>
              </div>
            ) : (
              <div className="col-md-5">
                <section className="profile you-quoted">
                  <div className="container">
                    <h3>You Quoted</h3>
                    <div className="profile-detail yorself">
                      <div className="row">
                        <div className="col-md-1 padding-0">
                          <a href="#!" className="profile-avatar">
                            <img src="/assets/images/you-quoted.png" />
                          </a>
                        </div>
                        <div className="col-md-11 padding-0">
                          <ul>
                            <li>
                              <h6>{location.state.item.payment_terms}</h6>
                              <h2>
                                <img
                                  src="/assets/images/rupee-blue.png"
                                  className="rupee"
                                />{" "}
                                <span>{location.state.item.bid_amount}/-</span>
                              </h2>
                              <p>Budget</p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                   
                  </div>
                </section>
              </div>
            )}
          </div>
        </div>
      </div>
      <Modal
          isOpen={isCancelModelopen}
          onRequestClose={cancelModelClose}
          style={customStyles}
          contentLabel="Example Modal"
          scrollable={true}
        >
          <div className="modal-dialog loginpopup reset-password-sec" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Cancel</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={cancelModelClose}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <label className="quote-detail-modal-label-margin">Are you sure you want to cancel the application?</label>

              <div className="passowrd-reset-omdal modal-body">
                <div className="terms-condition">
                  <div className="col-md-12">
                    <div className="form-group cp-old-password">
                    <textarea
                        className="form-control quote-detail-textarea-height"
                        required="required"
                        placeholder="Type reason..."
                        onChange={(e) => {
                          setComment(e.target.value);
                        }}
                      />
                     
                    </div>

                   
                    <button className="btn btn-default" onClick={cancelQuote}>Submit</button>
                  </div>
                  
                  
                </div>
              </div>
            </div>
          </div>
        </Modal>
      <ShareJob isOpen={openShareJob} toggle={toggleModel} jobData={location.state.item}/>
    </section>
  );
};

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    height: "100%",
    background: "transparent",
  },
  overlay: { zIndex: 100 },
};

export default connect(mapStateToProps, mapDispatchToProps)(MyQuoteDetailView);
